import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  background: var(--white-color);
`;

export default Wrapper;
